import { useBaseViewModel } from '@/common';
import { BusinessDomainEntity } from '@/domains/business-unit/entities';
import { GetListBusinessDomainUsecase } from '@/domains/business-unit/usecases/get-list-business-domain.usecase';
import { useState } from 'react';
import { QueryBusinessUnitPayload } from '@/domains/business-unit/ports/payloads';
import { BusinessUnitHttpRepository } from '../adapters/repositories/business-unit.http.repository';

export default function GetListBusinessDomain() {
  const getListBusinessDomainUC = new GetListBusinessDomainUsecase(
    new BusinessUnitHttpRepository(),
  );
  const { loading, error, catchAction } = useBaseViewModel();
  const [businessDomainData, setBusinessDomainData] = useState<BusinessDomainEntity[]>();

  const actionGetListBusinessDomain = async (payload?: QueryBusinessUnitPayload) => {
    await catchAction(async () => {
      const data = await getListBusinessDomainUC.run(payload);
      setBusinessDomainData(data);
    });
  };

  return {
    loading,
    error,
    businessDomainData,
    actionGetListBusinessDomain,
  };
}
